const initialState = {
  USER_PHONE: '',
};

// 获取预留手机号
export default function queryPhone(state = initialState, action) {
  switch (action.type) {
  case 'USER_PHONE':
    return { ...state, USER_PHONE: /^1\d{10}$/.test(action.payload) ? action.payload : '' };
  default:
    return state;
  }
}